module.exports = __webpack_public_path__ + "assets/img/in_(4).a09a0c3d.gif";